import { parseTemplate } from 'url-template';
import UserProductGroupErrorResponse from '~/Api/User/ProductGroup/UserProductGroupErrorResponse';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import UserProductGroupStatus from './UserProductGroupStatus';

export interface Result {
	items: UserProductGroupStatus[];
}

export default function removeProductsFromUserGroup(
	client: ApiClient,
	userId: string,
	groupId: string,
	productIds: string[]
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/products');
	const body = { items: productIds.map((id) => ({ id })) };

	return client
		.fetch(url.expand({ userId, groupId }), {
			method: 'DELETE',
			body: JSON.stringify(body),
		})
		.then((response) => response.json())
		.then((response) => ({
			items: response.items.map(
				(item: { id: string; status: string }) => new UserProductGroupStatus(item.id, item.status)
			),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, UserProductGroupErrorResponse));
}
